import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';

const classPrefix = 'publish-to-salesforce-dialog';

export namespace PublishToSalesforceDialogStyles {
    const centerByMaxHeight: number = 150;

    export const SalesforceCredentialsSection = cssClass(classPrefix, 'credentials-section', {
        paddingTop: CommonStyles.Sizes.SmallSpace,
    });

    export const CredentialsButton = cssClass(classPrefix, 'credentials-button', {
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: CommonStyles.Sizes.RowHeight
  });

    export const CredentialsDropdown = cssClass(classPrefix, 'credentials-dropdown', {
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center'
    });

    export const PermissionsDescriptionSection = cssClass(classPrefix, 'permissions-description', {
        marginTop: '0px',
        marginBottom: CommonStyles.Sizes.LineHeight
    });

    export const PublishToSectionLabel = cssClass(classPrefix, 'publish-to-label', {
        paddingBottom: CommonStyles.Sizes.DefaultSpace,
        paddingTop: CommonStyles.Sizes.DefaultSpace
    });

    export const AlertWidgetSection = cssClass(classPrefix, 'alert-widget', {
        paddingBottom: CommonStyles.Sizes.DefaultSpace,
    });

    export const LoadMoreAppsWidgetSection = cssClass(classPrefix, 'load-more-apps-widget', {
        marginBottom: CommonStyles.Sizes.LineHeight,
    });

    export const FilteringListStyle: React.CSSProperties = {
        minHeight: '240px',
        maxHeight: '240px',
        marginBottom: CommonStyles.Sizes.LineHeight,
        overflowY: 'auto',
        border: `1px solid ${TabStyles.Colors.L6}`
    };

    export const DialogStyle: React.CSSProperties = {
        marginBottom: centerByMaxHeight,
    };

    export const ActivitySpinnerStyle =  cssClass(classPrefix, 'activity-spinner', {
        padding: '25px 25px 50px',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 'normal'
    });
}
